export default __webpack_public_path__ + "static/media/review-9.233bea21.png";